import { v4 as uuidv4 } from 'uuid'

/**
 * @description used to create a unique uuid
 * this function have been created to use UUIDv4 once
 * @example createUuid() => 'f7b3b3b3-3b3b-3b3b-3b3b-3b3b3b3b3b3b'
 * @returns string
 */
export function createUuid(): string {
  return uuidv4()
}

/**
 * @description used to remove the domain from a url
 * @example removeDomainFromUrl('https://lamacompta.co/search?q=test') => '/search?q=test'
 * @returns string
 */
export function removeDomainFromUrl(url: string): string {
  if (!url) {
    throw new Error('url is required')
  }
  return url.replace(/^https?:\/\/[^/]+/, '')
}
